import React, { useEffect, useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import "./index.scss";
import ProductCard from "../../ProductCard";

import ProductService from "../../../services/product";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { useNavigate } from "react-router-dom";

const productService = new ProductService();

const BestSellers = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const loadProducts = async () => {
    setIsLoading(true);
    try {
      const response = await productService.getBestSellers();
      setProducts(
        Array.isArray(response.data) ? response.data : response.data?.data || []
      );
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des produits");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);

  return (
    <div className="best-sellers-section">
      <h2 className="mt-5">NOS BEST-SELLERS</h2>
      <Row className="gx-5 gy-5">
        {products.map((product) => (
          <Col key={product._id} lg={3} md={6}>
            <ProductCard product={product} />
          </Col>
        ))}
      </Row>
      <div className="see-more">
        <Button
          className="btn-plus"
          onClick={() => {
            navigate("/all-products?type=bestSeller");
            window.scrollTo(0, 0);
          }}>
          Voir Plus
        </Button>
      </div>
    </div>
  );
};

export default BestSellers;
